
import { defineComponent, ref, computed, onMounted, PropType } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useStore } from '@/store/index'
import { axios, ApiResponse } from '@/plugins/axios'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import { SeminarStatusAttributes } from '@/types/models/seminar-status'
import { SeminarAttributes } from '@/types/models/seminar'

export default defineComponent({
  props: {
    seminarDetails: {
      type: Object as PropType<SeminarAttributes | undefined>,
      'default': () => (undefined),
    }
  },
  components: { BaseFormSubmit, BaseAlert },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const btnDisabled = ref(false)
    const seminarStatus = ref<SeminarStatusAttributes | undefined>()
    const initialValues = computed(() => {
      return {
        seminar_status_id: 2,
        name: store.state.user.user?.name,
        email: store.state.user.user?.email,
      }
    })

    const schema = yup.object({
      seminar_status_id: yup.number().required(),
      name: yup.string().required().max(255),
      email: yup.string().required().email().max(255),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema, initialValues })

    const { value: seminar_status_id } = useField<number>('seminar_status_id')
    const { value: name } = useField<string>('name')
    const { value: email } = useField<string>('email')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post(`/seminar/apply/${route.params.seminar_id}`, values)
        .then(response => {
          store.commit('seminar/setSeminarDetails', response.data.payload)
          router.push(route.path)
        })
        .finally(() => btnDisabled.value = false)
    })

    const findStatusNameById = (id: number) => {
      if (Array.isArray(seminarStatus.value)) {
        return seminarStatus.value.find(x => x.id === id).name
      }
    }

    onMounted(() => {
      axios.get<ApiResponse<SeminarStatusAttributes>>('/seminar/status')
        .then(response => {
          seminarStatus.value = response.data.payload
        })
    })

    return {
      t,
      errors,
      seminar_status_id,
      name,
      email,
      onSubmit,
      btnDisabled,
      seminarStatus,
      findStatusNameById
    }
  },
})
